import React from "react";
import {
  Accordion,
  AccordionSummary,
  AccordionDetails,
  Typography,
  Box,
} from "@mui/material";
import ArrowForwardIosIcon from "@mui/icons-material/ArrowForwardIos";
const Faqs = ({ faqs }) => {
  return (
    <div className="flex justify-center lg:items-start items-center 2xl:px-16 xl:px-10 lg:px-8 md:px-5 px-0 w-full ">
      <div>
        <h2 className="text-[#d78558] md:text-5xl lg:text-left text-center sm:text-4xl font-robout text-3xl py-8 w-full font-black">
          FAQs
        </h2>
        <Box
          data-aos="fade-right"
          data-aos-delay="300"
          sx={{ width: "100%" }}
        >
          {faqs.map((faq, index) => (
            <Accordion
              key={index}
              elevation={0}
              disableGutters
              sx={{
                borderBottom: "1px solid #fafaf6a4",
                "&::before": { display: "none" },
                boxShadow: "none",
                backgroundColor: "transparent",
             
              }}
            >
              <AccordionSummary
                expandIcon={
                  <ArrowForwardIosIcon sx={{ fontSize: 16, color: "white" }} />
                }
                aria-controls={`panel${index}-content`}
                id={`panel${index}-header`}
                sx={{
                  paddingY: 3,
                  paddingX: 0,
                  fontWeight: "900",
                  "& .MuiAccordionSummary-content": {
                    margin: 0,
                    fontWeight: 900,
                  },
                }}
              >
                <Typography>
                  {" "}
                  <span className="font-black font-robout text-xl md:text-2xl xl:text-3xl text-white ">
                    {faq.question}
                  </span>
                </Typography>
              </AccordionSummary>
              <AccordionDetails sx={{ paddingX: 0, paddingBottom: 2 }}>
                <Typography>
                  <span className="text-white md:text-xl font-lg font-robout">
                    {faq.answer}
                  </span>
                </Typography>
              </AccordionDetails>
            </Accordion>
          ))}
        </Box>
      </div>
    </div>
  );
};

export default Faqs;
